
angular.module('taric.measure.mcc', ['common.model.geoarea', 'common.template.geoarea.popup', 'taric.model.measure',
        'common.template.measure.popup', 'common.template.additional-code.popup', 'common.template.additional-codes.popup',
        'common.template.condition.popup', 'taric.model.footnote', 'common.template.footnote.popup', 'common.template.footnotes.popup',
        'common.helper', 'common.filter.measuretype.description',
        'common.filter.geographicalarea.description',
        'common.directive.country', 'taric.model.monetaryunits',
        'common.filter.specialCharacterToHtml', 'taric.auth.model', 'common.filter.dutyexpression.description'])

    .controller('SearchMeasuresForNomenclatureController', function (CONSTANTS, $translatePartialLoader, MeasureForNomenclatureSearchModel, $uibModal, GeographicalAreaModel, $rootScope, $scope, $state, $stateParams, CommonHelper, $filter, $translate, MonetaryUnitsModel, AuthorizeModel, $timeout, countries, currencies, $location) {
        var searchMeasuresForNomCtrl = this;
        var model = MeasureForNomenclatureSearchModel;
        searchMeasuresForNomCtrl.init = function () {
            searchMeasuresForNomCtrl.searchCriteria = MeasureForNomenclatureSearchModel.getSearchCriteria();
            searchMeasuresForNomCtrl.installationCountry = CONSTANTS.installationCountry;
            searchMeasuresForNomCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            searchMeasuresForNomCtrl.dateFormat = CONSTANTS.dateFormat;
            searchMeasuresForNomCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            searchMeasuresForNomCtrl.searchMeasureResult = MeasureForNomenclatureSearchModel.getSearchMeasureResult();
            searchMeasuresForNomCtrl.controlCountry = {};
            searchMeasuresForNomCtrl.releaseManagement = CONSTANTS.releaseManagement;
            searchMeasuresForNomCtrl.currencies = currencies;

            searchMeasuresForNomCtrl.searchCriteria.currency = CommonHelper.getValidSelectedItem(
                searchMeasuresForNomCtrl.currencies.items,
                searchMeasuresForNomCtrl.searchCriteria.currency,
                CONSTANTS.installationCurrency);

            searchMeasuresForNomCtrl.model = MeasureForNomenclatureSearchModel;
            searchMeasuresForNomCtrl.model.loggedIn = AuthorizeModel.loggedIn;
            if (CONSTANTS.releaseManagement && AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer()) {
                searchMeasuresForNomCtrl.model.includeUnreleased = true;
                searchMeasuresForNomCtrl.showIncludeUnreleased = true;
            } else {
                searchMeasuresForNomCtrl.model.includeUnreleased = false;
                searchMeasuresForNomCtrl.showIncludeUnreleased = false;
            }

            // Auto-search when "Measures for nomenclature" is opened from other use cases:
            // "Query by nomenclature", "View quota", "Meursing"
            if (searchMeasuresForNomCtrl.shouldReload() && searchMeasuresForNomCtrl.validateExternalParameters()) {
                if (countries){

                    // get valid CountryCode
                    searchMeasuresForNomCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(
                        countries.items,
                        searchMeasuresForNomCtrl.searchCriteria.country,
                        null);
                }

                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        $rootScope.$on('clearSearchResult', function (event, data) {
            // If token has become invalid
            model.resetSearchResult();
            model.resetSearchCriteria();
            searchMeasuresForNomCtrl.searchCriteria = model.getSearchCriteria();
            searchMeasuresForNomCtrl.controlCountry.reload(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
        });

        searchMeasuresForNomCtrl.openDatePicker = function ($event) {
            searchMeasuresForNomCtrl.isDatePickerOpen = true;
        };

        searchMeasuresForNomCtrl.onDateChange = function (dateString) {
            searchMeasuresForNomCtrl.resetError();
            searchMeasuresForNomCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(searchMeasuresForNomCtrl.searchCriteria.simulationDate, dateString);
            searchMeasuresForNomCtrl.loadingReferenceData = true;
            searchMeasuresForNomCtrl.controlCountry.reload(searchMeasuresForNomCtrl.searchCriteria.simulationDate).then(() => {
                searchMeasuresForNomCtrl.loadingReferenceData = false;
            }, function (error) {
                searchMeasuresForNomCtrl.errorCode = error.data.code;
                searchMeasuresForNomCtrl.errorParams = error.data.params;
                searchMeasuresForNomCtrl.errorType = error.data.type;
                searchMeasuresForNomCtrl.loadingReferenceData = false;
            });
        };

        searchMeasuresForNomCtrl.search = function () {
            //Load data for the first page
            searchMeasuresForNomCtrl.loadDataFromServer(1);
        };

        //Load data for a given page
        searchMeasuresForNomCtrl.loadDataFromServer = function (pageNumber) {
            if (!searchMeasuresForNomCtrl.validateSearchForm()){
                return;
            }

            searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(pageNumber);
        };

        //Load data for a given page without validation
        searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation = function (pageNumber) {
            // Reset search result before searching
            searchMeasuresForNomCtrl.resetSearchResult();
            searchMeasuresForNomCtrl.updateAdditionalCodes();
            searchMeasuresForNomCtrl.searching = true;
            MeasureForNomenclatureSearchModel.queryMeasuresForNomenclature(pageNumber).then(function (searchMeasureResult) {
                searchMeasuresForNomCtrl.searchMeasureResult = searchMeasureResult;
                searchMeasuresForNomCtrl.searching = false;

                searchMeasuresForNomCtrl.searchMeasureResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                if (searchMeasuresForNomCtrl.searchMeasureResult.infoCode &&
                    "i8n.common.pastDate" === searchMeasuresForNomCtrl.searchMeasureResult.infoCode) {
                    searchMeasuresForNomCtrl.searchMeasureResult.infoParams = CONSTANTS.pastDate;
                }

                searchMeasuresForNomCtrl.updateBrowserURL();
            }, function (error) {
                searchMeasuresForNomCtrl.errorCode = error.data.code;
                searchMeasuresForNomCtrl.errorParams = error.data.params;
                searchMeasuresForNomCtrl.errorType = error.data.type;
                searchMeasuresForNomCtrl.searching = false;

                if (searchMeasuresForNomCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        /**
         * Query measures for commodity code
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/measure/mcc/search?sd={SimulationDate}&d={TradeDirection}&cc={CommodityCode}&ad={AdditionalCode}&co={Country}&cu={Currency}&l={Language}
         *
         * Example:
         * http://www.testenv.se/arctictariff-public-web/#!/taric/measure/mcc/search?sd=2015-01-01&d=I&cc=1005109000&ad=2550&co=US&cu=EUR&l=en
         */
        searchMeasuresForNomCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            var additionalCodes = '';
            for (let i = 0; i < searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes.length; i++) {
                if (i === 0) {
                    additionalCodes = searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes[i];
                } else {
                    additionalCodes = additionalCodes + ',' + searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes[i];
                }
            }
            
            // Do not keep additional parameter 'frm' because there is no return to caller page
            // in "Measures for nomenclature" use case
            $location.search({
                sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
                d : searchMeasuresForNomCtrl.searchCriteria.direction,
                cc: CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode),
                ad: additionalCodes,
                co: searchMeasuresForNomCtrl.searchCriteria.country,
                cu: searchMeasuresForNomCtrl.searchCriteria.currency,
                l : $translate.use()
            }).replace();
        };

        searchMeasuresForNomCtrl.resetSearchResult = function() {
            searchMeasuresForNomCtrl.searchMeasureResult = null;
            MeasureForNomenclatureSearchModel.resetSearchResult();
        };

        searchMeasuresForNomCtrl.print = function(options) {
        	
        	if (!searchMeasuresForNomCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningPrint');
            searchMeasuresForNomCtrl.updateAdditionalCodes();
            MeasureForNomenclatureSearchModel.queryMeasuresForNomenclature().then(function (searchMeasureResult) {

                searchMeasuresForNomCtrl.searchMeasureAllResult = searchMeasureResult;
                setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportBodyTable'), options);
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: searchMeasuresForNomCtrl.flagImg,
                        eu: searchMeasuresForNomCtrl.euImg,
                        validDate: $filter('date')(searchMeasuresForNomCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i18n.qry.mcc.pdf.report.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);
            }, function (error) {

                searchMeasuresForNomCtrl.errorCode = error.data.code;
                searchMeasuresForNomCtrl.errorParams = error.data.params;
                searchMeasuresForNomCtrl.errorType = error.data.type;
                $rootScope.$broadcast('stopSpinningPrint');

                if (searchMeasuresForNomCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        searchMeasuresForNomCtrl.updateAdditionalCodes = function(){
            var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
            searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes = additionalCodes;
        };

        /**
         * Get a distinct list of additional codes
         * @returns {Array}
         */
        searchMeasuresForNomCtrl.getAdditionalCodeList = function(){
            var result = [];
            var adco = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
            if (adco !== ""){
                result.push(adco);
            }

            searchMeasuresForNomCtrl.searchCriteria.additionalCodes.forEach(function(additionalCode){
                if(!searchMeasuresForNomCtrl.additionalCodeExists(result, additionalCode.id)){
                    result.push(additionalCode.id);
                }
            });
            return result;
        };

        searchMeasuresForNomCtrl.validateAdditionalCodes = function(){

            //Check for the number of additional codes to be used in the query parameters
            var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();

            if (additionalCodes.length > CONSTANTS.maxNumberOfAdditionalCodes) {
                searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcodes.exceed.limit";
                searchMeasuresForNomCtrl.errorParams = {param0: CONSTANTS.maxNumberOfAdditionalCodes};
                return false;
            }
            for (let i = 0; i < additionalCodes.length; i++){
                searchMeasuresForNomCtrl.errorCode = CommonHelper.validateAdditionalCode(additionalCodes[i]);
                if(searchMeasuresForNomCtrl.errorCode){
                    return false;
                }
            }

            // ACSMNT-3924 If the input code is the same as one that has already been added, set the input code to empty
            var code = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
            if (code !== "" && searchMeasuresForNomCtrl.getAdditionalCodePosition(code) > -1) {
                searchMeasuresForNomCtrl.searchCriteria.additionalCode = null;
            }

            return true;
        };

        /**
         * Check if the given adco exists in the given list
         * @param additionalCodeList The additional code list
         * @param adco The given additional code
         * @returns {boolean} true if exists else return false
         */
        searchMeasuresForNomCtrl.additionalCodeExists = function(additionalCodeList, adco){
            for (let i = 0; i < additionalCodeList.length; i++){
                if (additionalCodeList[i] === adco){
                    return true;
                }
            }
            return false;
        };

        /**
         * Add an additional code to the search list of additional codes
         * @param adco The additional code to be added
         */
        searchMeasuresForNomCtrl.addAdditionalCode = function (adco) {
            if (!searchMeasuresForNomCtrl.validateAddingAdditionalCode(adco)){
                return;
            }

            var adcoItem = {id: adco};
            searchMeasuresForNomCtrl.searchCriteria.additionalCodes.push(adcoItem);
            searchMeasuresForNomCtrl.searchCriteria.additionalCode = null;
        };

        /**
         * Remove a the given additional code from the list
         * @param adco The given additional code
         */
        searchMeasuresForNomCtrl.removeAdditionalCode = function (adco) {
            searchMeasuresForNomCtrl.handleError();
            var index = searchMeasuresForNomCtrl.getAdditionalCodePosition(adco);
            if (index > -1) {
                searchMeasuresForNomCtrl.searchCriteria.additionalCodes.splice(index, 1);
            }
        };

        /**
         * Validate additional code before adding
         * @param adco the additional code to be validated
         * @returns {boolean} The validation result
         */
        searchMeasuresForNomCtrl.validateAddingAdditionalCode = function (adco) {
            var result = true;
            adco = CommonHelper.removeSpaceCharacters(adco);
            if (adco === ""){
                searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcode.empty";
                result = false;
            } else if (searchMeasuresForNomCtrl.getAdditionalCodePosition(adco) > -1) {
                searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcode.exists";
                result = false;
            } else if(searchMeasuresForNomCtrl.searchCriteria.additionalCodes.length === CONSTANTS.maxNumberOfAdditionalCodes -1){
                searchMeasuresForNomCtrl.errorCode = "i8n.qry.mcc.search.error.additionalcodes.exceed.limit";
                searchMeasuresForNomCtrl.errorParams = {param0: CONSTANTS.maxNumberOfAdditionalCodes};
                result = false;
            }
            return result;
        };

        /**
         * Get the position of the given additional code in the list
         * @param adco The given additional code
         * @returns {number} The position of the additional code
         */
        searchMeasuresForNomCtrl.getAdditionalCodePosition = function (adco) {
            var index = -1;
            for (let i = 0; i < searchMeasuresForNomCtrl.searchCriteria.additionalCodes.length; i++){
                if(searchMeasuresForNomCtrl.searchCriteria.additionalCodes[i].id === adco){
                    index = i;
                    break;
                }
            }
            return index;
        };

        searchMeasuresForNomCtrl.onChangeAdditionalCode = function(){
            // ACSMNT-3907 Do not reset error to avoid clicking twice when searching with incorrect additionalCode
            searchMeasuresForNomCtrl.searchCriteria.additionalCode = CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.additionalCode);
            searchMeasuresForNomCtrl.searchCriteria.additionalCode = searchMeasuresForNomCtrl.searchCriteria.additionalCode.toUpperCase();
        };

        //Handle page change for the measure search result table
        searchMeasuresForNomCtrl.searchMeasureResultPageChanged = function (pageNumber) {
            searchMeasuresForNomCtrl.loadDataFromServerWithoutValidation(pageNumber);
        };

        searchMeasuresForNomCtrl.shouldReload = function(){
            return  searchMeasuresForNomCtrl.isExternalLink() || ($stateParams.frm === 'taric.duty.meursing' && $stateParams.ad && $stateParams.ad!== '7XXX');
        };

        searchMeasuresForNomCtrl.isExternalLink = function(){
            return  $stateParams.sd &&  $stateParams.cc &&
                (!$stateParams.frm || (($stateParams.frm !== 'adcoLookup') &&
                                        ($stateParams.frm !== 'ccLookup') &&
                                        ($stateParams.frm !== 'calDuties') &&
                                        ($stateParams.frm !== 'ccView')));
        };

        //Check whether the external parameters are valid or not
        searchMeasuresForNomCtrl.validateExternalParameters = function(){
            searchMeasuresForNomCtrl.resetError();
            return searchMeasuresForNomCtrl.validateCommodityCode() &&
                searchMeasuresForNomCtrl.validateAdditionalCodes() &&
                searchMeasuresForNomCtrl.validateSimulationDate();
        };

        //Check whether the search form is valid or not
        searchMeasuresForNomCtrl.validateSearchForm = function(){
            searchMeasuresForNomCtrl.resetError();
            return searchMeasuresForNomCtrl.validateCommodityCode() &&
                searchMeasuresForNomCtrl.validateCountryCode() &&
                searchMeasuresForNomCtrl.validateAdditionalCodes() &&
                searchMeasuresForNomCtrl.validateSimulationDate();
        };

        searchMeasuresForNomCtrl.validateCountryCode = function(){
            searchMeasuresForNomCtrl.errorCode = searchMeasuresForNomCtrl.controlCountry.validate();
            return searchMeasuresForNomCtrl.errorCode === null;
        };

        searchMeasuresForNomCtrl.validateCommodityCode = function () {
            searchMeasuresForNomCtrl.errorCode = CommonHelper.validateDeclarableCommodityCode(searchMeasuresForNomCtrl.searchCriteria.commodityCode, searchMeasuresForNomCtrl.searchCriteria.direction);
            return searchMeasuresForNomCtrl.errorCode === null;
        };

        searchMeasuresForNomCtrl.validateSimulationDate = function () {
            if (!CONSTANTS.dateRestrictionEnabled) {
                searchMeasuresForNomCtrl.errorCode = CommonHelper.validateSimulationDate(searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                if (searchMeasuresForNomCtrl.errorCode){
                    searchMeasuresForNomCtrl.errorParams = {param0: CONSTANTS.pastDate};
                }
            }
            return searchMeasuresForNomCtrl.errorCode === null;
        };

        searchMeasuresForNomCtrl.openOriginPopup = function (size, origin) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
                controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
                size: size,
                resolve: {
                    geoAreaMemberships: function () {
                        return GeographicalAreaModel.queryMembershipByGroupId(origin, searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                    },
                    origin: function () {
                        return origin;
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.openMeasurePopup = function (size, measure) {
            var valid = searchMeasuresForNomCtrl.validateSearchForm();
            if (!valid){
                return;
            }
            var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
            var preferenceCodesForMeasureOnly = false;
            var selectedPreferenceCode = null;
            var supportedPrefCodeVersion = null;
            const uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
            if (CommonHelper.compareDatesWithoutTime(searchMeasuresForNomCtrl.searchCriteria.simulationDate, uccApplicableDate) < 0) {
                supportedPrefCodeVersion = 'PRE_UCC';
            } else {
                if (CONSTANTS.supportedCalculationVersions.length === 1){
                    supportedPrefCodeVersion = CONSTANTS.supportedCalculationVersions[0];
                } else if (CONSTANTS.supportedCalculationVersions.length > 1) {
                    supportedPrefCodeVersion= CONSTANTS.supportedCalculationVersions[0];
                    supportedPrefCodeVersion+= "," + CONSTANTS.supportedCalculationVersions[1];
                }
            }

            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
                controller: 'MeasurePopupController as measurePopupCtrl',
                size: size,
                resolve: {
                    measureExtendedInfo: function (MeasurePopupModel) {
                        return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode),
                            searchMeasuresForNomCtrl.searchCriteria.country, searchMeasuresForNomCtrl.searchCriteria.direction, selectedPreferenceCode, additionalCodes, searchMeasuresForNomCtrl.searchCriteria.simulationDate, supportedPrefCodeVersion, measure.unreleased);
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.openConditionPopup = function (size, measure) {
            var valid = searchMeasuresForNomCtrl.validateSearchForm();
            if (!valid){
                return;
            }
            var monetaryUnitCode = searchMeasuresForNomCtrl.searchCriteria.currency;
            var additionalCodes = searchMeasuresForNomCtrl.getAdditionalCodeList();
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
                controller: 'ConditionPopupController as conditionPopupCtrl',
                size: size,
                resolve: {
                    measureConditionHeadResult: function (ConditionPopupModel) {
                        return ConditionPopupModel.getMeasureExtendedInfoForMeasureConditions(measure.sid, monetaryUnitCode, additionalCodes, searchMeasuresForNomCtrl.searchCriteria.simulationDate, searchMeasuresForNomCtrl.searchCriteria.direction, measure.unreleased).then(function(measureCondition){
                            var result = {count: 1};
                            var items = [];
                            items.push(measureCondition);
                            result.items = items;
                            return result;
                        });
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.viewAllMeasureConditions = function (size) {
            var valid = searchMeasuresForNomCtrl.validateSearchForm();
            if (!valid){
                return;
            }
            searchMeasuresForNomCtrl.updateAdditionalCodes();
            searchMeasuresForNomCtrl.loadingConditions = true;
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/condition/condition-popup.tmpl.html',
                controller: 'ConditionPopupController as conditionPopupCtrl',
                size: size,
                resolve: {
                    measureConditionHeadResult: function (MeasureForNomenclatureSearchModel) {
                        return MeasureForNomenclatureSearchModel.queryMeasureConditionsForNomenclature(1).then(function(result){
                            searchMeasuresForNomCtrl.loadingConditions = false;
                            return result;
                        }, function(error){
                            searchMeasuresForNomCtrl.loadingConditions = false;
                            searchMeasuresForNomCtrl.errorCode = error.data.code;
                            searchMeasuresForNomCtrl.errorParams = error.data.params;
                            searchMeasuresForNomCtrl.errorType = error.data.type;
                        });
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, searchMeasuresForNomCtrl.searchCriteria.simulationDate);
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.openAdditionalCodePopup = function (size, additionalCodeId) {
            var valid = searchMeasuresForNomCtrl.validateSearchForm();
            if (!valid){
                return;
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
                controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
                size: size,
                resolve: {
                    additionalCode: function (AdditionalCodePopupModel) {
                        return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, searchMeasuresForNomCtrl.searchCriteria.simulationDate, CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode));
                    },
                    simulationDate: function () {
                        return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.openQuotaPopup = function (size, measure) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
                controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
                size: size,
                resolve: {
                    quotaDefinitionExtendedInfo: function (TaricQuotaSearchModel) {

                        var inputOrigin = measure.geographicalArea.id;
                        if (searchMeasuresForNomCtrl.searchCriteria.country !== "" && searchMeasuresForNomCtrl.searchCriteria.country) {
                            inputOrigin = searchMeasuresForNomCtrl.searchCriteria.country;
                        }

                        var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, searchMeasuresForNomCtrl.searchCriteria.simulationDate).then(function (quotaExtendedInfo) {
                            return quotaExtendedInfo;
                        }, function (error) {
                            searchMeasuresForNomCtrl.errorCode = error.data.code;
                            searchMeasuresForNomCtrl.errorParams = error.data.params;
                            searchMeasuresForNomCtrl.errorType = error.data.type;
                            return;
                        });

                        return quotaExtendedInfo;
                    },
                    simulationDate: function () {
                        return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                    },
                    showCancelButton: function () {
                        return false;
                    },
                    country: function (){
                        return searchMeasuresForNomCtrl.searchCriteria.country;
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.selectCommodityCode = function (commodityCode, type) {

            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
                d: searchMeasuresForNomCtrl.searchCriteria.direction, frm: 'taric.measure.mcc', type: type
            });
        };

        searchMeasuresForNomCtrl.lookupAdditionalCode = function(additionalCode){
            $state.go('taric.adco.lookup', {
                frm: 'taric.measure.mcc',
                sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
                ad: CommonHelper.removeSpaceCharacters(additionalCode),
                mo: false
            });
        };

        searchMeasuresForNomCtrl.resetError = function() {
            searchMeasuresForNomCtrl.handleError(null);
        };

        searchMeasuresForNomCtrl.formatCommodityCode = function() {
            var formattedCommodityCode = $filter('commodityCode')(searchMeasuresForNomCtrl.searchCriteria.commodityCode);
            searchMeasuresForNomCtrl.searchCriteria.commodityCode = formattedCommodityCode;
        };

        searchMeasuresForNomCtrl.handleError = function(error) {
            if(!error){
                searchMeasuresForNomCtrl.errorCode = null;
                searchMeasuresForNomCtrl.errorParams = null;
            } else {
                searchMeasuresForNomCtrl.errorCode = error.errorCode;
                searchMeasuresForNomCtrl.errorParams = error.errorParams;
            }
        };

        searchMeasuresForNomCtrl.onCountryChange = function(country) {
            searchMeasuresForNomCtrl.searchCriteria.country = country;
        };

        searchMeasuresForNomCtrl.renderResultMiddleButtons = function() {
            return searchMeasuresForNomCtrl.enableCalculate() ||
                searchMeasuresForNomCtrl.enableMeursing() ||
                searchMeasuresForNomCtrl.enableAdditionalCodes() ||
                searchMeasuresForNomCtrl.enableMeasureFootnotes() ||
                searchMeasuresForNomCtrl.enableMeasureConditions();
        };

        searchMeasuresForNomCtrl.enableCalculate = function() {
            return !(CONSTANTS.webImportOnlyDutyCalc && searchMeasuresForNomCtrl.searchCriteria.direction === 'E');
        };

        searchMeasuresForNomCtrl.enableMeursing = function() {
            return searchMeasuresForNomCtrl.searchMeasureResult !== null &&
                searchMeasuresForNomCtrl.searchMeasureResult.hasMeursingComponents;
        };

        searchMeasuresForNomCtrl.enableMeasureConditions = function() {
            return searchMeasuresForNomCtrl.searchMeasureResult !== null &&
                searchMeasuresForNomCtrl.searchMeasureResult.hasConditions &&
                searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
        };

        searchMeasuresForNomCtrl.enableAdditionalCodes = function(){
            return searchMeasuresForNomCtrl.searchMeasureResult !== null &&
                searchMeasuresForNomCtrl.searchMeasureResult.additionalCodes.length > 0 &&
                searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
        };

        searchMeasuresForNomCtrl.enableMeasureFootnotes = function(){
            return searchMeasuresForNomCtrl.searchMeasureResult !== null &&
                searchMeasuresForNomCtrl.searchMeasureResult.measureFootnotes.length > 0 &&
                searchMeasuresForNomCtrl.searchMeasureResult.hasCountry;
        };

        searchMeasuresForNomCtrl.calculate = function() {
            if (!searchMeasuresForNomCtrl.validateSearchForm()) {
                return;
            }
            $state.go('taric.duty.calculate', {
                frm: 'taric.measure.mcc',
                sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
                cc: CommonHelper.removeSpaceCharacters(searchMeasuresForNomCtrl.searchCriteria.commodityCode),
                d: searchMeasuresForNomCtrl.searchCriteria.direction,
                ads: searchMeasuresForNomCtrl.searchCriteria.queryAdditionalCodes,
                co: searchMeasuresForNomCtrl.searchCriteria.country,
                cu: searchMeasuresForNomCtrl.searchCriteria.currency,
                ur: searchMeasuresForNomCtrl.searchCriteria.includeUnreleased
            });
        };

        searchMeasuresForNomCtrl.meursing = function() {
            if (!searchMeasuresForNomCtrl.validateSearchForm()) {
                return;
            }

            $state.go('taric.duty.meursing', {
                frm: 'taric.measure.mcc',
                sd: CommonHelper.getBookmarkDateString(searchMeasuresForNomCtrl.searchCriteria.simulationDate),
                co: searchMeasuresForNomCtrl.searchCriteria.country,
                cu: searchMeasuresForNomCtrl.searchCriteria.currency
            });
        };

        searchMeasuresForNomCtrl.viewAdditionalCodes = function(size) {
            var valid = searchMeasuresForNomCtrl.validateSearchForm();
            if (!valid){
                return;
            }
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/additional-codes/additional-codes-popup.tmpl.html',
                controller: 'AdditionalCodesPopupController as adcosPopupCtrl',
                size: size,
                resolve: {
                    simulationDate: function () {
                        return searchMeasuresForNomCtrl.searchCriteria.simulationDate;
                    },
                    additionalCodes: function () {
                        return searchMeasuresForNomCtrl.searchMeasureResult.additionalCodes;
                    },
                    commodityCode: function () {
                        return searchMeasuresForNomCtrl.searchMeasureResult.commodityCodeHead.commodityCode;
                    }
                }
            });
        };

        searchMeasuresForNomCtrl.viewMeasureFootnotes = function(size) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnotes/footnotes-popup.tmpl.html',
                controller: 'FootnotesPopupController as footnotesPopupCtrl',
                size: size,
                resolve: {
                    measureFootnotes: function () {
                        return searchMeasuresForNomCtrl.searchMeasureResult.measureFootnotes;
                    },
                    commodityCode: function () {
                        return searchMeasuresForNomCtrl.searchMeasureResult.commodityCodeHead.commodityCode;
                    }
                }
            });
        };
        
    	$scope.$on('printDocument', function(event, data) {

            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                searchMeasuresForNomCtrl.euImg = options.logo;
            }, true);

    		var url = "img/flags/" + searchMeasuresForNomCtrl.installationCountry + ".png";
    		CommonHelper.loadImage(url, 21, 14, function(options) {
    			
    			searchMeasuresForNomCtrl.flagImg = options.logo;
        		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, searchMeasuresForNomCtrl.print, true);
    		}, true);
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            searchMeasuresForNomCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                searchMeasuresForNomCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });


// WEBPACK FOOTER //
// ./app/taric/measure/mcc/measure-mcc.js